import { App } from '../App';
import { UI } from '../UI';
import './scss/color-variants.scss';

export const ColorVariants = (function () {
  const popopt = {
    content: function () {
      let src = $(this).data('image');
      return $(`<div class="img-bg-square"/>`).css({ backgroundImage: `url(${src})` });
    },
    html: true,
    trigger: 'hover',
    container: 'body',
    placement: 'top',
    template: `<div class="popover color-popover" role="tooltip">
                  <div class="arrow"></div>
                  <div class="popover-body"></div>
                  <h3 class="popover-header"></h3>
               </div>`
  };

  let init = (el, data = false) => {
    return new Promise((resolve, reject) => {
      if (!el || !data) {
        resolve();
        return $('.kt-badge--bbw-color').popover(popopt);
      }

      let template = require(`./tmpl/variants.hbs`);
      $(el).empty().html(template(data));

      $('.kt-badge--bbw-color', $(el)).popover(popopt);
      resolve();
    });
  };

  let reload = (data) => {
    if (!data) return;

    const elem = $(`#colors-variants-${data.id}`);

    if (!elem.length) return;

    // Sort Color variants
    data.variants = _.sortBy(data.variants, (v) => !v.approved);
    data.$lang = $lang;

    let template = require(`./tmpl/variants-content.hbs`);
    elem.empty().html(template(data));
    $('.kt-badge--bbw-color', elem).popover(popopt);
  };

  return {
    init,
    reload
  };
})();
